import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["playlistIds", "ownerTeamId", "showSuccessAlert"],
  _excluded2 = ["mutateAsync"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import api from 'utils/api';
import { setAlert, setSuccessAlert } from 'actions/alerts';
import contentKeys from 'actions/content/queryKeys';
import playlistKeys from './queryKeys';
function useUpdatePlaylists(_ref) {
  var playlistIds = _ref.playlistIds,
    ownerTeamId = _ref.ownerTeamId,
    _ref$showSuccessAlert = _ref.showSuccessAlert,
    showSuccessAlert = _ref$showSuccessAlert === void 0 ? true : _ref$showSuccessAlert,
    options = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var queryClient = useQueryClient();
  var teamPlaylistQueryKey = playlistKeys.playlists(ownerTeamId);
  function updatePlaylists(_x) {
    return _updatePlaylists.apply(this, arguments);
  }
  function _updatePlaylists() {
    _updatePlaylists = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(playlistData) {
      var updatePlaylistById, _updatePlaylistById, data;
      return _regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _updatePlaylistById = function _updatePlaylistById3() {
              _updatePlaylistById = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(id) {
                var data;
                return _regeneratorRuntime.wrap(function (_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      _context.next = 1;
                      return api('patch', "/api/playlists/".concat(id), null, playlistData);
                    case 1:
                      data = _context.sent;
                      return _context.abrupt("return", data);
                    case 2:
                    case "end":
                      return _context.stop();
                  }
                }, _callee);
              }));
              return _updatePlaylistById.apply(this, arguments);
            };
            updatePlaylistById = function _updatePlaylistById2(_x2) {
              return _updatePlaylistById.apply(this, arguments);
            };
            data = playlistIds.map(updatePlaylistById);
            return _context2.abrupt("return", Promise.all(data));
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return _updatePlaylists.apply(this, arguments);
  }
  var _useMutation = useMutation(_objectSpread(_objectSpread({
      mutationFn: updatePlaylists
    }, options), {}, {
      onSuccess: function onSuccess(data) {
        var promises = [queryClient.invalidateQueries({
          queryKey: contentKeys.contentLogs()
        }), queryClient.invalidateQueries({
          queryKey: playlistKeys.playlistList()
        }), queryClient.invalidateQueries({
          queryKey: playlistKeys.playlistAccessData
        }), queryClient.invalidateQueries({
          queryKey: playlistKeys.multiPlaylistsDetails(playlistIds)
        })];
        playlistIds.forEach(function (id) {
          var singlePlaylistQueryKey = playlistKeys.singlePlaylist(id);
          promises.push(queryClient.invalidateQueries({
            queryKey: singlePlaylistQueryKey
          }));
        });
        if (ownerTeamId) {
          promises.push(queryClient.invalidateQueries({
            queryKey: teamPlaylistQueryKey
          }));
        }
        return Promise.all(promises).then(function () {
          if (showSuccessAlert) {
            setSuccessAlert({
              title: t('alert_playlist_updated_successfully', {
                count: data.length
              })
            });
          }
        });
      },
      onError: function onError(data) {
        setAlert({
          title: t('alert_playlist_not_updated', {
            count: data.length
          })
        });
      }
    })),
    mutateAsync = _useMutation.mutateAsync,
    result = _objectWithoutProperties(_useMutation, _excluded2);
  return _objectSpread(_objectSpread({}, result), {}, {
    updatePlaylists: mutateAsync
  });
}
export default useUpdatePlaylists;